import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll to top on every route change. Uses the Lenis instance when
// present (immediate jump) and falls back to the native window scroll.
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        const lenis = window.__lenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
            lenis.scrollTo(0, { immediate: true, force: true });
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        }
    }, [pathname]);
    return null;
}
